import { Spinner, Text, useToast, VStack } from '@chakra-ui/react';
import axios from 'axios';
import { getKakaoRedirectUrl } from 'lib/api';
import usePathNavigate from 'lib/hook/usePathNavigate';
import { useEffect } from 'react';

function AuthKakao() {
  const { pathNavigate } = usePathNavigate();
  const toast = useToast();

  const getToken = async () => {
    const code = new URL(window.location.href).searchParams.get('code');
    const res = axios.post(
      'https://kauth.kakao.com/oauth/token',
      {
        grant_type: 'authorization_code',
        client_id: process.env.REACT_APP_KAKAO_CLIENT_ID,
        redirect_uri: getKakaoRedirectUrl(),
        code: code,
      },
      {
        headers: {
          'Content-type': 'application/x-www-form-urlencoded;charset=utf-8',
        },
      }
    );
    return res;
  };

  useEffect(() => {
    getToken()
      .then((res) => {
        if (res && res.data && res.data.access_token !== '') {
          localStorage.setItem('login_type', 'kakao');
          localStorage.setItem('login_token', res.data.access_token);
          pathNavigate(
            `/?c=${localStorage.getItem('channel')}&t=${
              'kakao' + res.data.access_token
            }`
          );
        } else {
          toast({
            title: '로그인 실패',
            description: '다시 로그인 해주세요.',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top',
          });
          pathNavigate(`/?c=${localStorage.getItem('channel')}`);
        }
      })
      .catch((err) => {
        toast({
          title: '로그인 실패',
          description: '다시 로그인 해주세요.',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
        pathNavigate(`/?c=${localStorage.getItem('channel')}`);
      });
  }, []);
  return (
    <VStack pt="100px" gap={'20px'}>
      <Spinner color="teal.500" size="xl" />
      <Text fontSize={'1rem'} fontWeight="medium">
        로그인 중입니다.
      </Text>
    </VStack>
  );
}

export default AuthKakao;
